import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class CloverService {
  constructor(private storageService: StorageService) {}

  getTerminalId() {
    return this.storageService.get('terminalId') ? this.storageService.get('terminalId') : null;
  }

  setTerminalId(terminaIdValue: string) {
    this.storageService.set('terminalId', terminaIdValue);
  }
}
